module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("\n          " + _vm._s(_vm.item.title) + " "), _c('span', {
    staticClass: "gray"
  }, [_vm._v("(wiadomość)")])]), _vm._v(" "), _c('p', {
    slot: "actions"
  }, [_c('ui-button', {
    attrs: {
      "type": "flat",
      "icon": "navigate_before",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'admin.messages.dashboard'
        })
      }
    }
  }, [_vm._v("Wróć")]), _vm._v(" "), _c('ui-button', {
    attrs: {
      "type": "flat",
      "icon": "refresh",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.getItem(_vm.item.id)
      }
    }
  }), _vm._v(" "), _c('ui-button', {
    attrs: {
      "type": "flat",
      "icon": "mode_edit",
      "color": "primary",
      "disabled": _vm.item.status != 1
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$router.push({
          name: 'admin.messages.edit',
          params: {
            id: _vm.id
          }
        })
      }
    }
  }, [_vm._v("Edytuj")]), _vm._v(" "), _c('ui-button', {
    attrs: {
      "type": "flat",
      "icon": "highlight_off",
      "color": "danger"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.remove(_vm.item)
      }
    }
  }, [_vm._v("Usuń")])], 1), _vm._v(" "), _c('table', {
    staticClass: "table info-table"
  }, [_c('tr', [_c('th', [_vm._v("\n            Podgląd\n          ")]), _vm._v(" "), _c('td', [_c('ui-button', {
    attrs: {
      "icon": "mode_edit",
      "color": "default"
    },
    on: {
      "click": function($event) {
        _vm.preview(_vm.item.id, 'html')
      }
    }
  }, [_vm._v("Podgląd wiadomości (html)")]), _vm._v(" "), _c('ui-button', {
    attrs: {
      "icon": "mode_edit",
      "color": "default"
    },
    on: {
      "click": function($event) {
        _vm.preview(_vm.item.id, 'text')
      }
    }
  }, [_vm._v("Podgląd wiadomości (text)")])], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("\n                  Status\n              ")]), _vm._v(" "), _c('td', [_c('message-status', {
    attrs: {
      "status": _vm.item.status
    }
  }), _vm._v(" "), _c('ui-button', {
    attrs: {
      "type": "flat",
      "icon": "refresh",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.getItem(_vm.item.id)
      }
    }
  })], 1)]), _vm._v(" "), (_vm.item.id) ? _c('tr', [_c('th', [_vm._v("\n                  Konto\n              ")]), _vm._v(" "), _c('td', [_c('a', {
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'admin.accounts.show',
          params: {
            id: _vm.item.email_account.id
          }
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.item.email_account.name))])])]) : _vm._e(), _vm._v(" "), (_vm.item.id) ? _c('tr', [_c('th', [_vm._v("\n                  Adresaci\n              ")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                      Wysyłka do:\n                      "), _c('message-send-to-info', {
    attrs: {
      "item": _vm.item
    }
  })], 1), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("\n                      W grupach: "), _vm._l((_vm.item.email_groups), function(g) {
    return _c('a', {
      staticClass: "badge",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.$router.push({
            name: 'admin.email-groups.show',
            params: {
              id: g.id
            }
          })
        }
      }
    }, [_vm._v(_vm._s(g.name))])
  })], 2), _vm._v(" "), (_vm.item.status == 1) ? _c('div', [(_vm.toSendTotal) ? _c('p', [_vm._v("\n                      Ilość subskrybentów którym zostanie wysłana wiadomość: "), _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.toSendTotal))]), _c('br'), _vm._v(" "), _c('ui-button', {
    attrs: {
      "color": "default"
    },
    on: {
      "click": function($event) {
        _vm.showSubscribers()
      }
    }
  }, [_vm._v("Pokaż sybskrybentów")])], 1) : _vm._e(), _vm._v(" "), (_vm.toSendTotal == 0) ? _c('ui-alert', {
    attrs: {
      "type": "warning",
      "icon": "warning",
      "dismissible": false
    }
  }, [_vm._v("Ta wiadomość nie zostanie do nikogo wysłana!")]) : _vm._e()], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.item.use_template) ? _c('tr', [_c('th', [_vm._v("\n                  Używa szablonu\n              ")]), _vm._v(" "), _c('td', [_vm._v("\n                  Szablon html: "), _c('strong', [_vm._v(_vm._s(_vm.item.template_html ? _vm.item.template_html : 'Domyślny'))]), _c('br'), _vm._v(" Szablon tekstowy: "), _c('strong', [_vm._v(_vm._s(_vm.item.template_text ? _vm.item.template_text : 'Domyślny'))])])]) : _vm._e()])]), _vm._v(" "), _c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("\n          Wyślij testowo wiadomość na podany niżej e-mail\n      ")]), _vm._v(" "), _c('message-test-form', {
    attrs: {
      "item": _vm.item
    }
  })], 1), _vm._v(" "), (_vm.item.status == 3 || _vm.item.status == 4) ? _c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("\n          Status wysyłki\n      ")]), _vm._v(" "), _c('p', {
    slot: "actions"
  }, [_c('ui-button', {
    attrs: {
      "type": "flat",
      "icon": "refresh",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.reload($event)
      }
    }
  })], 1), _vm._v(" "), (_vm.item.id) ? _c('messages-send-log', {
    attrs: {
      "id": _vm.item.id
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('ui-modal', {
    ref: "modal1",
    attrs: {
      "title": _vm.modal.title,
      "hide-footer": true,
      "size": "large"
    }
  }, [(_vm.item.id) ? _c('messages-send-to-list', {
    attrs: {
      "id": _vm.item.id
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6090a254","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/messages/Show.vue
// module id = 265
// module chunks = 0